import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-pincodewise-statement',
  templateUrl: './pincodewise-statement.component.html',
  styleUrls: ['./pincodewise-statement.component.scss'],
})
export class PincodewiseStatementComponent implements OnInit {
  pincodewisedata;
  total_pin_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  filteredpincodewisesubcout = [];
  pincodewisesubcoutprinting = [];
  sundayankDate;
  dispatchankDate;

  constructor(
    private dialogref: MatDialogRef<PincodewiseStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  updateStatus: any = false
  issuedate: any
  state: any
  district: any
  country: any
  distributionMode: any
  subDistributionMode: any
  type: any
  taluka:any
  pincode:any
  ngOnInit(): void {
    this.pincodewisedata = this.data['data'];
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issueDate']
    this.state = this.data.state;
    this.district = this.data.district;
    this.country = this.data.country;
    this.distributionMode = this.data.distributionMode;
    this.subDistributionMode = this.data.subDistributionMode;
    this.type = this.data.type;
     this.taluka = this.data.taluka;
     this.pincode = this.data.pincode;
    // console.log('pincodewisedata', this.pincodewisedata);


   this.calculation()
    if (this.updateStatus) {
      this.getAllDistributerCopiesListForPincodewiseStatement();
    } else {
      this.getPincodeStatementList();
    }
    // console.log('pincodewisesubcoutprinting', this.pincodewisesubcoutprinting);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  getPincodeStatementList() {
    this.pincodewisesubcoutprinting = []
    const request = {
      issue_date: this.issuedate,
      countryName: this.country[0],
      districtName: this.district,
      stateName: this.state[0],
      talukaName: this.taluka,
      pincode: this.pincode,
    }
    this.service.getPincodewiseStatementList(request).subscribe((data: any) => {
      this.pincodewisesubcoutprinting = data;
      this.total_pin_sub_count = data[0].total_sub123;
      this.totalparcel = data[0].parcel_total;
      this.totalanksankhya = data[0].book_bundle_total;
    });
  }

  existCount: any
  getPincodewiseEntryCheck() {
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
      district: this.district[0],
      state: this.state[0]
    }
    this.service.getPincodewiseEntryCheck(request).subscribe((data: any) => {
      this.existCount = data[0].RECORD_COUNT;
      if (this.existCount != 0) {
        alert(this.existCount + " Records Are Already saved");
      }

    });
  }

//Old Method
  // saveSubscriptionBarcodesDataEntry() {
  //   console.log(this.pincodewisesubcoutprinting);
  //   const filteredData = this.pincodewisesubcoutprinting.map((item) => ({
  //     issue_date: this.convertDateFormat1(this.sundayankDate),
  //     country: "भारत",
  //     state: this.state[0],
  //     added_by: 1,
  //     publish_date: this.convertDateFormat(this.dispatchankDate),
  //     delivery_mode: item.delivery_mode,
  //     dispatch_date: this.convertDateFormat(this.dispatchankDate),
  //     district: this.district[0],


  //     pincode1: item.pincode1,
  //     no_of_book_bundle1: item.parcel1 != undefined ? item.parcel1.split("=")[1] : "",
  //     count_bundle1: item.parcel1 != undefined ? item.parcel1.split("=")[0] : "",
  //     no_subscriber1: item.sub1,
  //     total1: this.total_pin_sub_count,

  //     pincode2: item.pincode2,
  //     no_of_book_bundle2: item.parcel2 != undefined ? item.parcel2.split("=")[1] : "",
  //     count_bundle2: item.parcel2 != undefined ? item.parcel2.split("=")[0] : "",
  //     no_subscriber2: item.sub2,
  //     total2: this.total_pin_sub_count,

  //     pincode3: item.pincode3,
  //     no_of_book_bundle3: item.parcel3 != undefined && item.parcel3 != 0 && item.parcel3 != "" && item.parcel3 != null ? item.parcel3.split("=")[1] : "",
  //     count_bundle3: item.parcel3 != undefined && item.parcel3 != 0 && item.parcel3 != "" && item.parcel3 != null ? item.parcel3.split("=")[0] : "",
  //     no_subscriber3: item.sub3,
  //     total3: this.total_pin_sub_count,
  //     allDistributerId1:item.id1,
  //     allDistributerId2:item.id2,
  //     allDistributerId3:item.id3,
  //   }));
  //   console.log(filteredData);
  //   this.service.savePincodewiseStatement(filteredData).subscribe((data) => {
  //     alert('Pincodewise Statements Save Successfully!');
  //   });
  // }

saveSubscriptionBarcodesDataEntry() {
  console.log(this.pincodewisesubcoutprinting);

  // Helper: safely parse parcel values like "3=15" => { count: "3", books: "15" }
  const parseParcel = (parcel: any) => {
    if (parcel === null || parcel === undefined || parcel === 0 || parcel === '') {
      return { count: '', books: '' };
    }

    // If it's already an object with count/books fields
    if (typeof parcel === 'object') {
      if ('count' in parcel || 'books' in parcel) {
        return { count: parcel.count ?? '', books: parcel.books ?? '' };
      }
      // fallback: stringify and try to parse if it contains '='
      try {
        const s = JSON.stringify(parcel);
        if (s.includes('=')) {
          const [count, books] = s.split('=');
          return { count: count ?? '', books: books ?? '' };
        }
      } catch (e) {
        // ignore and return empty
      }
      return { count: '', books: '' };
    }

    // For primitive types: ensure it's a string and contains '='
    const str = String(parcel);
    if (!str.includes('=')) {
      return { count: '', books: '' };
    }
    const parts = str.split('=');
    return { count: parts[0] ?? '', books: parts[1] ?? '' };
  };

  const filteredData = this.pincodewisesubcoutprinting.map((item: any) => {
    const p1 = parseParcel(item.parcel1);
    const p2 = parseParcel(item.parcel2);
    const p3 = parseParcel(item.parcel3);

    return {
      issue_date: this.convertDateFormat1(this.sundayankDate),
      country: "भारत",
      state: (this.state && this.state.length) ? this.state[0] : "",
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: item.delivery_mode,
      dispatch_date: this.convertDateFormat(this.dispatchankDate),
      district: (this.district && this.district.length) ? this.district[0] : "",

      // Parcel 1
      pincode1: item.pincode1,
      count_bundle1: p1.count,
      no_of_book_bundle1: p1.books,
      no_subscriber1: item.sub1 ?? "",
      total1: this.total_pin_sub_count ?? 0,

      // Parcel 2
      pincode2: item.pincode2,
      count_bundle2: p2.count,
      no_of_book_bundle2: p2.books,
      no_subscriber2: item.sub2 ?? "",
      total2: this.total_pin_sub_count ?? 0,

      // Parcel 3
      pincode3: item.pincode3,
      count_bundle3: p3.count,
      no_of_book_bundle3: p3.books,
      no_subscriber3: item.sub3 ?? "",
      total3: this.total_pin_sub_count ?? 0,

      allDistributerId1: item.id1,
      allDistributerId2: item.id2,
      allDistributerId3: item.id3
    };
  });

  console.log(filteredData);

  this.service.savePincodewiseStatement(filteredData).subscribe(
    (data) => {
      alert('Pincodewise Statements Save Successfully!');
    },
    (error) => {
      console.error('Save failed', error);
      alert('Failed to save pincodewise statements.');
    }
  );
}


  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormat1(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }

  deletePincodewiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deletePincodewiseStatement(request).subscribe((data: any) => {

      alert(data.message);
      this.getPincodeStatementList();
    });
  }


  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.pincodewisesubcoutprinting.forEach(item => item.selected = this.checkAll);

    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.pincodewisesubcoutprinting.every(item => item.selected);
    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }

  // Old Correct code 
  // getAllDistributerCopiesList() {
  //   // this.filtereddistrictwisesubcout = []
  //   const request = {
  //     "issue_date": this.issuedate,
  //     "countryName": this.country[0],
  //     "stateName": this.state[0],
  //     "distributionMode": this.distributionMode || this.type,
  //     "subDistributionMode": this.subDistributionMode || "जी.पी.ओ",
  //     "districtName": this.district,
  //     "talukaName": "",
  //     "pincode": ""
  //   }
  //   this.service.getAllDistributerCopiesList(request).subscribe((data: any) => {
  //     let dataList = data.data;
  //     this.calculation()
  //     console.log(this.filteredpincodewisesubcout)
  //     const districtSummary: any = {};
  //     debugger
  //     dataList.forEach(item => {
  //       const { district, taluka, prati, pincode,id } = item;

  //       if (!districtSummary[pincode]) {
  //         districtSummary[pincode] = {
  //           district: district,
  //           talukaCount: 0,
  //           pratiSum: 0,
  //           pincode: pincode,
  //           id:id
  //         };
  //       }

  //       districtSummary[pincode].talukaCount += 1; // Count every record (even if taluka name is same)
  //       districtSummary[pincode].pratiSum += Number(prati);
  //     });

  //     // Convert to list
  //     const districtWiseList = Object.values(districtSummary).map((entry: any) => ({
  //       district: entry.district,
  //       talukaCount: entry.talukaCount,
  //       pratiSum: entry.pratiSum,
  //       parcel: `${entry.talukaCount}=${entry.pratiSum}`,
  //       pincode:entry.pincode,
  //       id:entry.id
  //     }));


  //     // Step 1: Create a map from districtWiseList
  //     const districtMap = new Map<string, any>();

  //     districtWiseList.forEach(entry => {
  //       districtMap.set(entry.pincode, {
  //         talukaCount: entry.talukaCount,
  //         pratiSum: entry.pratiSum,
  //         parcel: entry.parcel,
  //         id:entry.id
  //       });
  //     });

  //     // Step 2: Merge into filtereddistrictwisesubcout
  //     let filtereddistrictwisesubcout1 = this.pincodewisesubcoutprinting.map(item => {
  //       // Get parcel for taluka1
  //       const match1 = districtMap.get(item.pincode1);
  //       const parcel1 = match1?.parcel || "0=0";
  //       const id1 = match1?.id;

  //       // Get parcel for taluka2
  //       const match2 = districtMap.get(item.pincode2);
  //       const parcel2 = match2?.parcel || "0=0";
  //       const id2 = match2?.id;

  //       // Get parcel for taluka3
  //       const match3 = districtMap.get(item.pincode3);
  //       const parcel3 = match3?.parcel || "0=0";
  //       const id3 = match3?.id;

        

  //       return {
  //         ...item,
  //         parcel1,
  //         parcel2,
  //         parcel3,
  //         id1,
  //         id2,
  //         id3,
  //       };
  //     });


  //     // this.total_sub_count = filtereddistrictwisesubcout1.reduce((sum, item) => {
  //     //   return sum + Number(item.sub);
  //     // }, 0);
  //     this.totalparcel = filtereddistrictwisesubcout1.reduce((sum, item) => {
  //       return sum + Number(item.parcel1.split("=")[0])+ Number(item.parcel2.split("=")[0])+ Number(item.parcel3.split("=")[0]);
  //     }, 0);
  //     this.totalanksankhya = filtereddistrictwisesubcout1.reduce((sum, item) => {
  //       return sum + Number(item.parcel1.split("=")[1])+ Number(item.parcel2.split("=")[1])+ Number(item.parcel3.split("=")[1]);
  //     }, 0);
  //     this.pincodewisesubcoutprinting = filtereddistrictwisesubcout1;
  //     console.log(this.pincodewisesubcoutprinting);

  //   });


  // }

  getAllDistributerCopiesListForPincodewiseStatement() {
  const request = {
    issue_date: this.issuedate,
    countryName: this.country?.[0] || this.country,

    // ✅ FIXED
    stateName: Array.isArray(this.state) ? this.state : [this.state],
    districtName: Array.isArray(this.district) ? this.district : [this.district],

    distributionMode: Array.isArray(this.distributionMode)
      ? this.distributionMode[0]
      : this.distributionMode || this.type,

    subDistributionMode: this.subDistributionMode || "जी.पी.ओ",

    talukaName: [],
    pincode: []
  };

  this.service.getAllDistributerCopiesListForPincodewiseStatement(request).subscribe((data: any) => {

    let dataList = data.data || [];

    const districtSummary: any = {};

    // ✅ FIXED LOGIC (MAIN)
    dataList.forEach(item => {
      const { pincode, prati, issueSellerName } = item;

      if (!districtSummary[pincode]) {
        districtSummary[pincode] = {
          pincode: pincode,
          uniqueSellers: new Set(),
          pratiSum: 0,
          id: item.id
        };
      }

      districtSummary[pincode].uniqueSellers.add(issueSellerName);
      districtSummary[pincode].pratiSum += Number(prati);
    });

    const districtWiseList = Object.values(districtSummary).map((entry: any) => ({
      pincode: entry.pincode,
      talukaCount: entry.uniqueSellers.size,
      pratiSum: entry.pratiSum,
      parcel: `${entry.uniqueSellers.size}=${entry.pratiSum}`,
      id: entry.id
    }));

    const districtMap = new Map<string, any>();

    districtWiseList.forEach(entry => {
      districtMap.set(entry.pincode, entry);
    });

    let updated = this.pincodewisesubcoutprinting.map(item => {

      const getParcel = (pin) => {
        const match = districtMap.get(pin);
        return match ? match.parcel : "0=0";
      };

      const getId = (pin) => {
        const match = districtMap.get(pin);
        return match ? match.id : null;
      };

      return {
        ...item,
        parcel1: getParcel(item.pincode1),
        parcel2: getParcel(item.pincode2),
        parcel3: getParcel(item.pincode3),
        id1: getId(item.pincode1),
        id2: getId(item.pincode2),
        id3: getId(item.pincode3)
      };
    });

    // ✅ SAFE TOTAL CALCULATION
    // const getCount = (val: string, index: number) => {
    //   if (!val || !val.includes('=')) return 0;
    //   return Number(val.split('=')[index]) || 0;
    // };

    const getCount = (val: string, index: number) => {
  if (!val || typeof val !== 'string' || !val.includes('=')) return 0;

  const parts = val.split('=');
  return Number(parts[index]) || 0;
};

    this.totalparcel = updated.reduce((sum, item) => {
      return sum +
        getCount(item.parcel1, 0) +
        getCount(item.parcel2, 0) +
        getCount(item.parcel3, 0);
    }, 0);

    this.totalanksankhya = updated.reduce((sum, item) => {
      return sum +
        getCount(item.parcel1, 1) +
        getCount(item.parcel2, 1) +
        getCount(item.parcel3, 1);
    }, 0);

    this.pincodewisesubcoutprinting = updated;
  });
}

  //Old Code 
  // calculation() {
  //   this.getPincodewiseEntryCheck();
  //   this.total_pin_sub_count = 0;
  //   this.totalparcel = 0;
  //   this.totalanksankhya = 0;
  //   let tempdata = this.uniqueid(this.pincodewisedata, (a) => a['pincode']);

  //   // console.log({ tempdata });
  //   this.filteredpincodewisesubcout = [];
  //   for (let index = 0; index < Object.keys(tempdata).length; index++) {
  //     let arr = this.pincodewisedata.filter(
  //       (a) => a['pincode'] == tempdata[index]['pincode']
  //     );
  //     // console.log('*********Started***********');
  //     // console.log({ arr });

  //     let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
  //     // console.log({ delivery_mode_unique });

  //     let totalTapalCount = 0;
  //     let parcelval = 0;
  //     let anksankhya = 0;
  //     for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
  //       let arr1 = arr.filter(
  //         (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
  //       );
  //       // console.log({ arr1 });
  //       let hasteTapalJPO = [];
  //       if (arr1[0]['delivery_mode'] === 'टपाल') {
  //         totalTapalCount = Object.keys(arr1).length;
  //         hasteTapalJPO = arr1.filter(
  //           (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
  //         );
  //         if (hasteTapalJPO.length > 0) {
  //           let hasteTapalJPOUnique = this.uniqueid(
  //             hasteTapalJPO,
  //             (a) => a['distribution_rep']
  //           );
  //           // console.log({ hasteTapalJPOUnique });
  //           parcelval = hasteTapalJPOUnique.length;
  //           hasteTapalJPOUnique.map((tapal) => {
  //             let ank = hasteTapalJPO.filter(
  //               (a) => a['distribution_rep'] === tapal['distribution_rep']
  //             );
  //             // console.log({ ank });
  //             anksankhya += ank.length;
  //           });
  //           // console.log({ anksankhya });
  //         }
  //         // if(a['dis_sub_mode'] == 'जी.पी.ओ'){
  //         //    parcelval=totalTapalCount;
  //         // }

  //         //  anksankhya += ank.length;
  //         console.log({ totalTapalCount });
  //       } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
  //         // console.log('this might be hand delivery');

  //         hasteTapalJPO = arr1.filter(
  //           (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
  //         );
  //         // console.log({ hasteTapalJPO });
  //         if (hasteTapalJPO.length > 0) {
  //           let hasteTapalJPOUnique = this.uniqueid(
  //             hasteTapalJPO,
  //             (a) => a['distribution_rep']
  //           );
  //           // console.log({ hasteTapalJPOUnique });
  //           parcelval = hasteTapalJPOUnique.length;
  //           hasteTapalJPOUnique.map((tapal) => {
  //             let ank = hasteTapalJPO.filter(
  //               (a) => a['distribution_rep'] === tapal['distribution_rep']
  //             );
  //             // console.log({ ank });
  //             anksankhya += ank.length;
  //           });
  //           // console.log({ anksankhya });
  //         }
  //       }
  //     }
  //     // console.log({ totalTapalCount });
  //     // console.log('*********Ended***********');

  //     this.filteredpincodewisesubcout.push({
  //       name: tempdata[index]['name'],
  //       Subscription_Type: tempdata[index]['Subscription_Type'],
  //       address: tempdata[index]['address'],
  //       country: tempdata[index]['country'],
  //       delivery_mode: tempdata[index]['delivery_mode'],
  //       district: tempdata[index]['district'],
  //       pincode: tempdata[index]['pincode'],
  //       state: tempdata[index]['state'],
  //       sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
  //       taluka: tempdata[index]['taluka'],
  //       sub: totalTapalCount,
  //       parcel: `${parcelval}=${anksankhya}`,
  //     });

  //     this.total_pin_sub_count += totalTapalCount;
  //     this.totalparcel += parcelval;
  //     this.totalanksankhya += anksankhya;
  //   }


  //   // console.log('filteredpincodewisesubcout', this.filteredpincodewisesubcout);

  //   let totalcount = Object.keys(this.filteredpincodewisesubcout).length;
  //   let tempcount = Math.ceil(totalcount / 3);
  //   // console.log(Math.ceil(totalcount / 3));
  //   let val = 0;
  //   let a = 0;
  //   let b = 1;
  //   let c = 2;
  //   for (let i = 0; i < tempcount; i++) {
  //     val += 3;
  //     this.pincodewisesubcoutprinting.push({
  //       pincode1: 0,
  //       sub1: 0,
  //       parcel1: 0,
  //       pincode2: 0,
  //       sub2: 0,
  //       parcel2: 0,
  //       pincode3: 0,
  //       sub3: 0,
  //       parcel3: 0,
  //     });
  //     for (
  //       let index = 0;
  //       index < Object.keys(this.filteredpincodewisesubcout).length;
  //       index++
  //     ) {
  //       if (index < val) {
  //         // console.log('val works');
  //         if (index == a) {
  //           // console.log('a works');

  //           this.pincodewisesubcoutprinting[i]['pincode1'] =
  //             this.filteredpincodewisesubcout[index]['pincode'];
  //           this.pincodewisesubcoutprinting[i]['sub1'] =
  //             this.filteredpincodewisesubcout[index]['sub'];
  //           this.pincodewisesubcoutprinting[i]['parcel1'] =
  //             this.filteredpincodewisesubcout[index]['parcel'];
  //         } else if (index == b) {
  //           // console.log('b works');

  //           this.pincodewisesubcoutprinting[i]['pincode2'] =
  //             this.filteredpincodewisesubcout[index]['pincode'];
  //           this.pincodewisesubcoutprinting[i]['sub2'] =
  //             this.filteredpincodewisesubcout[index]['sub'];
  //           this.pincodewisesubcoutprinting[i]['parcel2'] =
  //             this.filteredpincodewisesubcout[index]['parcel'];
  //         } else if (index == c) {
  //           // console.log('c works');

  //           this.pincodewisesubcoutprinting[i]['pincode3'] =
  //             this.filteredpincodewisesubcout[index]['pincode'];
  //           this.pincodewisesubcoutprinting[i]['sub3'] =
  //             this.filteredpincodewisesubcout[index]['sub'];
  //           this.pincodewisesubcoutprinting[i]['parcel3'] =
  //             this.filteredpincodewisesubcout[index]['parcel'];
  //         } else {
  //           // console.log('continue works');

  //           continue;
  //         }
  //       }
  //     }

  //     a += 3;
  //     b += 3;
  //     c += 3;
  //   }
  // }

// calculation() {
//   this.getPincodewiseEntryCheck();
//   this.total_pin_sub_count = 0;
//   this.totalparcel = 0;
//   this.totalanksankhya = 0;

//   let tempdata = this.uniqueid(this.pincodewisedata, (a) => a['pincode']);

//   this.filteredpincodewisesubcout = [];

//   for (let index = 0; index < Object.keys(tempdata).length; index++) {
//     if (!tempdata[index]['pincode']) continue; // Skip blank pincode

//     let arr = this.pincodewisedata.filter(
//       (a) => a['pincode'] == tempdata[index]['pincode']
//     );

//     let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);

//     let totalTapalCount = 0;
//     let parcelval = 0;
//     let anksankhya = 0;

//     for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
//       let arr1 = arr.filter(
//         (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
//       );

//       let hasteTapalJPO = [];

//       if (arr1[0]['delivery_mode'] === 'टपाल') {
//         totalTapalCount = arr1.length;

//         hasteTapalJPO = arr1.filter(
//           (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
//         );

//         if (hasteTapalJPO.length > 0) {
//           let hasteTapalJPOUnique = this.uniqueid(
//             hasteTapalJPO,
//             (a) => a['distribution_rep']
//           );

//           parcelval = hasteTapalJPOUnique.length;

//           hasteTapalJPOUnique.map((tapal) => {
//             let ank = hasteTapalJPO.filter(
//               (a) => a['distribution_rep'] === tapal['distribution_rep']
//             );
//             anksankhya += ank.length;
//           });
//         }
//       } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
//         hasteTapalJPO = arr1.filter(
//           (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
//         );

//         if (hasteTapalJPO.length > 0) {
//           let hasteTapalJPOUnique = this.uniqueid(
//             hasteTapalJPO,
//             (a) => a['distribution_rep']
//           );

//           parcelval = hasteTapalJPOUnique.length;

//           hasteTapalJPOUnique.map((tapal) => {
//             let ank = hasteTapalJPO.filter(
//               (a) => a['distribution_rep'] === tapal['distribution_rep']
//             );
//             anksankhya += ank.length;
//           });
//         }
//       }
//     }

//     this.filteredpincodewisesubcout.push({
//       name: tempdata[index]['name'],
//       Subscription_Type: tempdata[index]['Subscription_Type'],
//       address: tempdata[index]['address'],
//       country: tempdata[index]['country'],
//       delivery_mode: tempdata[index]['delivery_mode'],
//       district: tempdata[index]['district'],
//       pincode: tempdata[index]['pincode'],
//       state: tempdata[index]['state'],
//       sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
//       taluka: tempdata[index]['taluka'],
//       sub: totalTapalCount,
//       parcel: `${parcelval}=${anksankhya}`,
//     });

//     this.total_pin_sub_count += totalTapalCount;
//     this.totalparcel += parcelval;
//     this.totalanksankhya += anksankhya;
//   }

//   let totalcount = this.filteredpincodewisesubcout.length;
//   let tempcount = Math.ceil(totalcount / 3);

//   let a = 0,
//     b = 1,
//     c = 2;

//   for (let i = 0; i < tempcount; i++) {
//     let row = {
//       pincode1: "",
//       sub1: "",
//       parcel1: "",
//       pincode2: "",
//       sub2: "",
//       parcel2: "",
//       pincode3: "",
//       sub3: "",
//       parcel3: ""
//     };

//     let rowHasData = false; // MAIN FIX

//     for (let index = 0; index < totalcount; index++) {
//       if (index === a) {
//         let obj = this.filteredpincodewisesubcout[index];
//         row.pincode1 = obj.pincode || "";
//         row.sub1 = obj.sub === 0 ? "" : obj.sub;
//         row.parcel1 = obj.parcel === "0=0" ? "" : obj.parcel;
//         rowHasData = true;
//       } else if (index === b) {
//         let obj = this.filteredpincodewisesubcout[index];
//         row.pincode2 = obj.pincode || "";
//         row.sub2 = obj.sub === 0 ? "" : obj.sub;
//         row.parcel2 = obj.parcel === "0=0" ? "" : obj.parcel;
//         rowHasData = true;
//       } else if (index === c) {
//         let obj = this.filteredpincodewisesubcout[index];
//         row.pincode3 = obj.pincode || "";
//         row.sub3 = obj.sub === 0 ? "" : obj.sub;
//         row.parcel3 = obj.parcel === "0=0" ? "" : obj.parcel;
//         rowHasData = true;
//       }
//     }

//     // ⛔ DO NOT PUSH IF ROW HAS NO DATA (MAIN FIX)
//     if (rowHasData) {
//       this.pincodewisesubcoutprinting.push(row);
//     }

//     a += 3;
//     b += 3;
//     c += 3;
//   }
// }

calculation() {
  this.getPincodewiseEntryCheck();
  this.total_pin_sub_count = 0;
  this.totalparcel = 0;
  this.totalanksankhya = 0;

  let tempdata = this.uniqueid(this.pincodewisedata, (a) => a['pincode']);

  this.filteredpincodewisesubcout = [];

  for (let index = 0; index < Object.keys(tempdata).length; index++) {
    if (!tempdata[index]['pincode']) continue;

    let arr = this.pincodewisedata.filter(
      (a) => a['pincode'] == tempdata[index]['pincode']
    );

    let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);

    let totalTapalCount = 0;
    let parcelval = 0;
    let anksankhya = 0;

for (let j = 0; j < delivery_mode_unique.length; j++) {

  let arr1 = arr.filter(
    (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
  );

  // ✅ COUNT SUBSCRIBERS
  totalTapalCount += arr1.length;

  // ✅ COMMON FILTER (NO DUPLICATE LOGIC)
  let validData = arr1.filter(
    (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
  );

  if (validData.length > 0) {

    // let uniqueReps = this.uniqueid(
    //   validData,
    //   (a) => a['distribution_rep']
    // );
    let uniqueReps = this.uniqueid(validData, (a) => a['distribution_rep']);

    // ✅ FIX: ADD instead of overwrite
    // parcelval += uniqueReps.length;
    parcelval += uniqueReps.length;

    uniqueReps.forEach(rep => {
      let ank = validData.filter(
        (a) => a['distribution_rep'] === rep['distribution_rep']
      );

      // ✅ FIX: ADD properly
      anksankhya += ank.length;
    });
  }
}

    this.filteredpincodewisesubcout.push({
      name: tempdata[index]['name'],
      Subscription_Type: tempdata[index]['Subscription_Type'],
      address: tempdata[index]['address'],
      country: tempdata[index]['country'],
      delivery_mode: tempdata[index]['delivery_mode'],
      district: tempdata[index]['district'],
      pincode: tempdata[index]['pincode'],
      state: tempdata[index]['state'],
      sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
      taluka: tempdata[index]['taluka'],
      sub: totalTapalCount,
      // parcel: `${parcelval}=${anksankhya}`,
      parcel: (parcelval > 0 || anksankhya > 0)
  ? `${parcelval}=${anksankhya}`
  : "",
    });

    this.total_pin_sub_count += totalTapalCount;
    this.totalparcel += parcelval;
    this.totalanksankhya += anksankhya;
  }

  let totalcount = this.filteredpincodewisesubcout.length;
  let tempcount = Math.ceil(totalcount / 3);

  let a = 0, b = 1, c = 2;

  this.pincodewisesubcoutprinting = [];

  for (let i = 0; i < tempcount; i++) {
    let row = {
      pincode1: "", sub1: "", parcel1: "",
      pincode2: "", sub2: "", parcel2: "",
      pincode3: "", sub3: "", parcel3: ""
    };

    let rowHasData = false;

    [a, b, c].forEach(index => {
      if (index < totalcount) {
        let obj = this.filteredpincodewisesubcout[index];

        if (index === a) {
          row.pincode1 = obj.pincode || "";
          row.sub1 = obj.sub === 0 ? "" : obj.sub;
          row.parcel1 = obj.parcel === "0=0" ? "" : obj.parcel;
          rowHasData = true;
        }

        if (index === b) {
          row.pincode2 = obj.pincode || "";
          row.sub2 = obj.sub === 0 ? "" : obj.sub;
          row.parcel2 = obj.parcel === "0=0" ? "" : obj.parcel;
          rowHasData = true;
        }

        if (index === c) {
          row.pincode3 = obj.pincode || "";
          row.sub3 = obj.sub === 0 ? "" : obj.sub;
          row.parcel3 = obj.parcel === "0=0" ? "" : obj.parcel;
          rowHasData = true;
        }
      }
    });

    if (rowHasData) {
      this.pincodewisesubcoutprinting.push(row);
    }

    a += 3;
    b += 3;
    c += 3;
  }
}

}
